import React from 'react';
import { toast } from 'react-hot-toast';

const ColorPresets = ({ onSelectPreset }) => {
  const presets = [
    {
      name: 'Default Blue',
      primary: '#1575DB',
      primaryLight: '#9ac0eaff',
      primaryDark: '#08223dff',
      secondary: '#3a4878ff',
      secondaryLight: '#4a6475ff',
      secondaryDark: 'rgba(25, 34, 63, 1)',
    },
    {
      name: 'Dark Ocean',
      primary: '#000000',
      primaryLight: '#111827',
      primaryDark: '#000000',
      secondary: '#3b82f6',
      secondaryLight: '#93c5fd',
      secondaryDark: '#2563eb',
    },
    {
      name: 'Forest Green',
      primary: '#14532d',
      primaryLight: '#166534',
      primaryDark: '#052e16',
      secondary: '#65a30d',
      secondaryLight: '#a3e635',
      secondaryDark: '#4d7c0f',
    },
    {
      name: 'Royal Purple',
      primary: '#4c1d95',
      primaryLight: '#5b21b6',
      primaryDark: '#3b0764',
      secondary: '#ec4899',
      secondaryLight: '#f9a8d4',
      secondaryDark: '#be185d',
    },
    {
      name: 'Warm Orange',
      primary: '#431407',
      primaryLight: '#7c2d12',
      primaryDark: '#27070a',
      secondary: '#f97316',
      secondaryLight: '#fdba74',
      secondaryDark: '#c2410c',
    }
  ];

  const handlePresetClick = (preset) => {
    const colorData = {
      PRIMARY: preset.primary,
      PRIMARY_LIGHT: preset.primaryLight,
      PRIMARY_DARK: preset.primaryDark,
      SECONDARY: preset.secondary,
      SECONDARY_LIGHT: preset.secondaryLight,
      SECONDARY_DARK: preset.secondaryDark,
    };
    
    // Apply colors immediately for a responsive feel but don't save to API
    document.documentElement.style.setProperty('--color-primary', colorData.PRIMARY);
    document.documentElement.style.setProperty('--color-primary-light', colorData.PRIMARY_LIGHT);
    document.documentElement.style.setProperty('--color-primary-dark', colorData.PRIMARY_DARK);
    document.documentElement.style.setProperty('--color-secondary', colorData.SECONDARY);
    document.documentElement.style.setProperty('--color-secondary-light', colorData.SECONDARY_LIGHT);
    document.documentElement.style.setProperty('--color-secondary-dark', colorData.SECONDARY_DARK);
    
    toast.success('Color preset applied! Click Save Changes to save.');
    
    // Notify parent component
    if (onSelectPreset) {
      onSelectPreset(colorData);
    }
  };

  return React.createElement('div', { className: "mb-8" }, [
    React.createElement('h2', { className: "text-xl font-semibold mb-4", key: 'preset-title' }, "Color Presets"),
    React.createElement('div', { className: "grid grid-cols-2 md:grid-cols-5 gap-4", key: 'preset-grid' },
      presets.map((preset, index) => 
        React.createElement('button', {
          key: `preset-${index}`,
          className: "p-4 border rounded-lg hover:shadow-md transition text-center",
          onClick: () => handlePresetClick(preset)
        }, [
          React.createElement('div', {
            className: "w-full h-8 rounded mb-2",
            style: { background: `linear-gradient(to right, ${preset.primary} 0%, ${preset.primaryLight} 50%, ${preset.secondary} 100%)` },
            key: `preset-color-${index}`
          }),
          React.createElement('span', { key: `preset-name-${index}` }, preset.name)
        ])
      )
    )
  ]);
};

export default ColorPresets;